// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.salary-flow-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
}

.salary-flow-title {
  padding: 16px;
  font-size: 18px;
  font-weight: 700;
  text-align: center;
  color: var(--text-primary);
  background: var(--bg-primary);
  border-bottom: 1px solid var(--border-color);
}

.salary-flow-content {
  flex: 1 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.salary-flow-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
}

.salary-flow-label {
  font-size: 13px;
  color: var(--text-secondary);
  font-weight: 600;
  margin-bottom: 8px;
}

.salary-flow-img {
  width: 100%;
  border-radius: var(--radius-md);
  background: var(--bg-tertiary);
  object-fit: contain;
  max-height: 80vh;
  cursor: zoom-in;
}

.salary-flow-empty {
  padding: 40px 16px;
  text-align: center;
  color: var(--text-muted);
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/SalaryFlowPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB","sourcesContent":[".salary-flow-page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-primary);\n}\n\n.salary-flow-title {\n  padding: 16px;\n  font-size: 18px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--text-primary);\n  background: var(--bg-primary);\n  border-bottom: 1px solid var(--border-color);\n}\n\n.salary-flow-content {\n  flex: 1;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n}\n\n.salary-flow-item {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 24px;\n}\n\n.salary-flow-label {\n  font-size: 13px;\n  color: var(--text-secondary);\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.salary-flow-img {\n  width: 100%;\n  border-radius: var(--radius-md);\n  background: var(--bg-tertiary);\n  object-fit: contain;\n  max-height: 80vh;\n  cursor: zoom-in;\n}\n\n.salary-flow-empty {\n  padding: 40px 16px;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
